import L from 'leaflet'

export const isAlreadyMapLayerAdded = map => {
    if (!map) return false

    let isAdded = false
    map.eachLayer(layer => {
        if (layer instanceof L.HeatLayer) {
            isAdded = true
        }
    })

    return isAdded
}

export const deleteMapLayer = map => {
    map.eachLayer(layer => {
        if (layer instanceof L.HeatLayer) {
            map.removeLayer(layer)
        }
    })
}

export const isDevicePinMovedAfterLastHeartbeat = device =>
    device.floor_plan_pin_moved_at &&
    new Date(device.floor_plan_pin_moved_at) > new Date(device.last_heartbeat)
